(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('BrokerageRegionSearch', BrokerageRegionSearch);

    BrokerageRegionSearch.$inject = ['$resource'];

    function BrokerageRegionSearch($resource) {
        var resourceUrl =  'api/_search/brokerage-regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
